module.exports = __webpack_public_path__ + "img/placeholder-image.74c837d0.svg";